export default {
  common: {
    appName: 'テチャン',
    loading: '読み込み中...',
    error: 'エラーが発生しました',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    confirm: '確認',
    close: '閉じる',
    search: '検索',
    add: '追加',
    create: '作成',
    update: '更新',
    welcome: 'ようこそ',
    logout: 'ログアウト',
    login: 'ログイン',
    signup: '会員登録',
    and: 'および'
  },
  header: {
    home: 'ホーム',
    search: '検索',
    playlists: 'プレイリスト',
    community: 'コミュニティ',
    fanchantArchive: 'ファンチャントアーカイブ',
    concerts: '公演情報',
    practice: '練習モード',
    profile: 'プロフィール',
    admin: '管理者',
    bookmarks: 'ブックマーク',
    announcements: 'お知らせ',
    myPlaylists: 'マイプレイリスト',
    newPlaylist: '新規プレイリスト'
  },
  home: {
    title: '🎯 テチャンで特別な音楽体験を',
    subtitle: 'K-POP、バラード、トロットまで！',
    subtitle2: '自分だけのプレイリストを作って友達と共有しましょう。',
    startButton: '今すぐ始める →',
    feature1: '無制限プレイリスト作成',
    feature2: '30秒区間練習モード',
    feature3: '友達とプレイリスト共有',
    myPlaylists: '{name}さんのプレイリスト',
    defaultUser: 'ユーザー',
    guide: 'ガイド',
    noPlaylists: 'まだプレイリストがありません。新しいプレイリストを作成しましょう！',
    popularPlaylists: '🔥 人気プレイリスト TOP 10',
    recentPlaylists: '🆕 最近作成されたプレイリスト',
    sortByPlays: '再生回数',
    sortByCopies: 'コピー回数',
    songs: '曲',
    songCount: '曲数',
    copyCount: 'コピー回数',
    updatedAt: '更新日',
    share: '共有',
    plays: '回再生',
    copies: '回コピー',
    by: 'by',
    viewDetail: '👁️ 詳細を見る',
    copyPlaylist: '📋 コピー'
  },
  search: {
    title: '曲を検索',
    tabMusic: '🎵 音楽/動画検索',
    tabPopular: '🔥 人気プレイリスト',
    tabTags: '🏷️ タグで検索',
    guide: 'ガイド',
    placeholder: '曲名、アーティストを検索',
    placeholderTag: 'タグでプレイリストを検索',
    searching: '検索中...',
    noResults: '検索結果がありません',
    tryAgain: '別のキーワードで試してください',
    recentSearches: '最近の検索',
    addToPlaylist: 'プレイリストに追加',
    quotaExceeded: 'YouTube API割当量を超過しました',
    tryLater: '後でもう一度お試しください',
    todaySearch: '今日の検索',
    remaining: '残り検索',
    times: '回',
    unlimited: '無制限',
    quotaExhausted: '⚠️ 検索回数消費',
    linkGuideTitle: '💎 無制限検索のヒント！',
    linkGuideTitleExceeded: '検索回数がなくなりましたか？',
    linkGuideText: 'YouTubeリンクを直接入力すると',
    linkGuideHighlight: '検索回数を消費せずに',
    linkGuideHighlightExceeded: '検索回数の減算なしで',
    linkGuideText2: 'すぐに検索できます！',
    linkGuideExample: '例: https://www.youtube.com/watch?v=videoId または https://youtu.be/videoId',
    filterTitle: '検索タイプ（複数選択可）:',
    filterOfficial: '公式',
    filterLyrics: '歌詞',
    filterLive: 'ライブ',
    filterCover: 'カバー',
    filterAudio: 'オーディオ',
    allPlaylists: 'すべてのプレイリスト',
    myPlaylists: 'マイプレイリスト',
    popularTags: '🔥 人気タグ',
    recommendedKeywords: '🔍 おすすめ検索ワード',
    recentSearchesTitle: '最近の検索ワード',
    popularKeywords: '人気検索ワード',
    noRecentSearches: '最近の検索ワードがありません',
    quotaCacheMessage: '次の検索ワードをクリックするとキャッシュされた結果を確認できます:',
    noCacheData: 'キャッシュデータがありません。別のキーワードをお試しください。',
    // 検索方法タブ
    searchByKeyword: 'キーワード検索',
    searchByLink: 'リンクで検索',
    // URL入力
    urlPlaceholder: 'YouTubeリンクを入力（例: https://www.youtube.com/watch?v=...）',
    addToPlayer: 'プレーヤーに追加',
    urlHelp: 'YouTubeおよびYouTube Musicリンクに対応。リンク検索は割当量を消費しません。',
    loading: '読み込み中...',
    // アラートメッセージ
    alertInvalidUrl: '有効なYouTube URLではありません。',
    alertVideoInfoFailed: '動画情報の取得に失敗しました。',
    alertSongAddedToPlayer: 'プレーヤーに追加されました。',
    alertSongAddFailed: '曲の追加に失敗しました'
  },
  playlist: {
    title: 'プレイリスト',
    type: 'プレイリスト',
    loading: 'プレイリストを読み込み中...',
    retry: '再試行',
    backToList: 'リストに戻る',
    backToListShort: '← リストへ',
    guide: 'ガイド',
    myPlaylists: 'マイプレイリスト',
    publicPlaylists: '公開プレイリスト',
    createNew: '新規プレイリスト',
    editPlaylist: 'プレイリスト編集',
    deletePlaylist: 'プレイリスト削除',
    playlistName: 'プレイリスト名',
    description: '説明',
    descriptionPlaceholder: 'プレイリストの説明を入力...',
    isPublic: '公開',
    isPrivate: '非公開',
    clickToPublic: 'クリックして公開に変更',
    clickToPrivate: 'クリックして非公開に変更',
    editTitle: 'タイトル編集',
    editDescription: '説明編集',
    songs: '曲',
    addSongs: '曲を追加',
    removeSong: '曲を削除',
    playSong: '再生',
    playAll: 'すべて再生',
    shuffle: 'シャッフル',
    confirmDelete: '本当に削除しますか？',
    emptySongList: '曲がありません',
    addFirstSong: '最初の曲を追加',
    createdBy: '作成者',
    totalDuration: '総再生時間',
    songList: '曲リスト',
    saveBtn: '保存',
    cancelBtn: 'キャンセル',
    totalCopies: '総コピー数',
    times: '回',
    share: '共有',
    shareDropdown: '共有 ▼',
    shareToCommunity: 'コミュニティに共有',
    unshareToCommunity: 'コミュニティ共有解除',
    copyLink: 'リンクをコピー',
    copyToMyPlaylist: 'マイプレイリストにコピー',
    privatePlaylist: '非公開プレイリスト',
    shareOnlyPublic: '公開プレイリストのみ共有できます',
    tags: 'タグ',
    comments: 'コメント',
    showComments: 'コメントを表示',
    hideComments: 'コメントを非表示',
    sortBy: '並び替え:',
    sortCustom: 'カスタム順',
    sortTitle: 'タイトル順',
    sortArtist: 'アーティスト順',
    sortAddedDate: '追加日順',
    sortDuration: '再生時間順',
    tableTitle: 'タイトル',
    tableArtist: 'アーティスト',
    tableAlbum: 'アルバム',
    tableAddedDate: '追加日',
    tableDuration: '再生時間',
    addToQueueNext: '現在の曲の次に追加',
    addToQueueLast: '再生リストの最後に追加',
    removeFromPlaylist: 'プレイリストから削除',
    emptyPlaylist: 'プレイリストが空です',
    addSongsToStart: '曲を追加してください',
    recentActivity: '最近のアクティビティ',
    copyPlaylistModal: 'プレイリストをコピー',
    copyPlaylistConfirm: 'このプレイリストをマイプレイリストにコピーしますか？',
    copyWarning: 'コピーされたプレイリストはマイプレイリストに追加されます。',
    copyBtn: 'コピー',
    addSongModal: '曲を追加',
    addBySearch: '検索で追加',
    addByLink: 'リンクで追加',
    searchPlaceholder: 'アーティスト名または曲名を検索...',
    todaySearches: '今日の検索:',
    remaining: '残り検索:',
    quotaExhausted: '検索回数消費',
    linkAddTip: '無制限検索のヒント！',
    linkAddTipExhausted: '検索回数がなくなりましたか？',
    linkAddDesc1: 'リンクで追加タブを使用すると',
    linkAddHighlight: '検索回数の減算なしで',
    linkAddHighlightAlt: '検索回数を消費せずに',
    linkAddDesc2: 'すぐに追加できます！',
    linkAddInstruction: '上のタブで「🔗 リンクで追加」を選択してください',
    urlPlaceholder: 'YouTube URLを入力... (例: https://www.youtube.com/watch?v=...)',
    urlSupport: 'YouTube、YouTube Musicリンクに対応',
    searchResults: '検索結果',
    items: '件',
    viewCount: '回視聴',
    prevPage: '前へ',
    nextPage: '次へ',
    pageInfo: 'ページ',
    searching: '検索中...',
    noResults: '検索結果がありません',
    closeModal: '閉じる',
    loading: '読み込み中...',
    // Additional translations for script messages
    hour: '時間',
    minute: '分',
    noDescription: '説明がありません。',
    // Alert messages
    alertTitleRequired: 'プレイリストのタイトルは空にできません。',
    alertUpdateFailed: 'プレイリストの更新に失敗しました。',
    alertSongsAddedToQueue: '{count}曲が再生リストに追加されました',
    alertSongsAddedShuffled: '{count}曲が再生リストに追加されました（シャッフル）',
    alertSongRemoveFailed: '曲の削除に失敗しました。',
    alertSharedToCommunity: 'プレイリストがコミュニティに共有されました！',
    alertUnsharedFromCommunity: 'コミュニティ共有が解除されました。',
    alertCommunityShareFailed: '❌ コミュニティ共有処理に失敗しました。',
    alertPlaylistCopied: '「{name}」プレイリストがマイプレイリストにコピーされました！',
    alertCannotCopyOwn: '自分のプレイリストはコピーできません。',
    alertCopyFailed: '❌ プレイリストのコピーに失敗しました。',
    alertMadePublic: '✅ プレイリストが公開に変更されました！\n共有できるようになりました。',
    alertMakePublicFailed: '❌ プレイリストの公開設定に失敗しました。',
    alertPrivacyChangedPublic: '🌍 プレイリストが公開に変更されました！\n他のユーザーが閲覧・共有できるようになりました。',
    alertPrivacyChangedPrivate: '🔒 プレイリストが非公開に変更されました！\n自分だけが閲覧できます。',
    alertPrivacyChangeFailed: '❌ プレイリストの公開/非公開設定に失敗しました。',
    alertDeleted: 'プレイリストが正常に削除されました。',
    alertDeleteFailed: 'プレイリストの削除に失敗しました。',
    alertSearchFailed: '検索に失敗しました: {message}',
    alertSongAdded: '✅ 「{title}」がプレイリストに追加されました。',
    alertSongAddFailed: '曲の追加に失敗しました: {message}',
    alertInvalidUrl: '正しいYouTube URLではありません。',
    alertVideoInfoFailed: '動画情報の取得に失敗: {status}',
    // Confirm messages
    confirmRemoveSong: 'この曲をプレイリストから削除しますか？',
    confirmClearPlaylist: 'このプレイリストのすべての曲を削除しますか？',
    confirmDeletePlaylist: '「{name}」プレイリストを完全に削除しますか？\n\nこの操作は元に戻せません。',
    confirmMakePublic: '🔒 このプレイリストは非公開です。\n\n共有するにはプレイリストを公開に設定する必要があります。\n\n今すぐ公開に変更しますか？',
    confirmPrivacyChange: 'プレイリストを{currentStatus}から{newStatus}に変更しますか？\n\n{details}',
    privacyDetailsPublic: '• 公開に変更すると、他のユーザーがこのプレイリストを閲覧できます。\n• 共有リンクを生成できます。',
    privacyDetailsPrivate: '• 非公開に変更すると、他のユーザーがこのプレイリストを閲覧できなくなります。\n• 既存の共有リンクには「非公開プレイリスト」と表示されます。',
    statusPublic: '公開',
    statusPrivate: '非公開',
    // Error messages
    errorNotFound: '❌ プレイリストが見つかりません。',
    errorForbidden: '🔒 このプレイリストにアクセスする権限がありません。',
    errorServerError: '⚠️ サーバーエラーが発生しました。後でもう一度お試しください。',
    errorLoadFailed: '❌ プレイリストの読み込みに失敗しました。',
    errorNetworkFailed: '🌐 ネットワーク接続を確認してください。'
  },
  player: {
    play: '再生',
    pause: '一時停止',
    previous: '前へ',
    next: '次へ',
    repeat: 'リピート',
    shuffle: 'シャッフル',
    volume: 'ボリューム',
    selectSong: '再生する曲を選択',
    playlist: '再生リスト',
    songsCount: '曲',
    clearAll: '再生リスト全削除',
    removeFromPlaylist: '再生リストから削除',
    lyrics: '歌詞',
    subtitle: '字幕',
    noSubtitle: '字幕なし',
    sections: '区間',
    sectionManagement: '区間管理',
    addSection: '区間追加',
    sectionSelect: '区間選択',
    sectionSelecting: '📐 区間選択中...',
    selectedSection: '選択された区間',
    sectionRepeat: '区間リピート',
    sectionRepeating: 'リピート中',
    saveSection: '区間を保存',
    deleteSection: '選択された区間を削除',
    sectionSaveModal: '🎵 区間を保存',
    sectionName: '区間名',
    sectionNamePlaceholder: '例: サビ、ブリッジ、キリングパートなど',
    sectionLyrics: '歌詞/字幕',
    sectionLyricsPlaceholder: '一緒に歌う部分の歌詞を入力すると練習に役立ちます。',
    pronunciation: '発音記号',
    pronunciationPlaceholder: '日本語以外の歌詞の場合、発音表記を追加できます。',
    required: '*',
    cancel: 'キャンセル',
    save: '保存',
    startTime: '開始時間',
    endTime: '終了時間',
    noLyrics: '歌詞がありません',
    loading: '読み込み中...',
    player: 'プレーヤー',
    openPlayer: 'プレーヤーを開く',
    closePlayer: 'プレーヤーを閉じる',
    expandFullscreen: '全画面表示',
    closeFullscreen: '全画面を閉じる',
    clearAllPlaylist: '全削除',
    selectSongPlaceholder: '曲を選択してください',
    artist: 'アーティスト',
    upcomingSection: '秒後',
    section: '区間',
    sectionTime: '区間:',
    repeatMode: 'リピート',
    deleteBtn: '削除',
    saveBtn: '保存',
    lyricsSaveModal: '🎤 歌詞区間を保存',
    lyricsEditModal: '🎤 歌詞区間を編集',
    lyricsText: '歌詞',
    lyricsTextPlaceholder: 'この区間の歌詞を入力',
    pronunciationGuide: '発音ガイド',
    pronunciationGuidePlaceholder: '日本語以外の歌詞の場合、発音表記を追加できます。',
    lineNumber: '行番号',
    lineNumberPlaceholder: '歌詞の順序（並び替え用）',
    shareWithOthers: '他のユーザーと共有',
    confirmRemoveSong: 'この曲をプレーヤーから削除しますか？',
    confirmClearPlaylist: '再生リストをすべて削除しますか？',
    confirmDeleteLyrics: '「{name}」歌詞区間を削除しますか？',
    alertLyricsRequired: '歌詞区間名と歌詞を入力してください。',
    alertLyricsUpdated: '歌詞区間「{name}」が更新されました！',
    alertLyricsSaved: '歌詞区間「{name}」が保存されました！',
    alertLyricsSaveFailed: '歌詞区間の保存に失敗しました。もう一度お試しください。',
    alertLyricsDeleted: '「{name}」歌詞区間が削除されました。',
    alertLyricsDeleteFailed: '歌詞区間の削除に失敗しました。もう一度お試しください。',
    errorInvalidVideo: '無効な動画ID',
    errorHtml5: 'HTML5プレーヤーで再生できないコンテンツです',
    errorNotFound: '動画が見つかりません（削除されたか非公開）',
    errorEmbedNotAllowed: '動画の所有者が埋め込みを許可していません',
    errorUnknown: '不明なエラー',
    errorCode: 'コード'
  },
  profile: {
    title: 'プロフィール',
    loading: 'プロフィール情報を読み込み中...',
    error: 'エラーが発生しました',
    retry: '再試行',
    changeImage: '📷 画像を変更',
    nickname: 'ニックネーム',
    nicknameDefault: 'ニックネームを設定',
    nicknamePlaceholder: 'ニックネームを入力',
    save: '保存',
    cancel: 'キャンセル',
    username: 'ユーザー名',
    email: 'メールアドレス',
    emailNotRegistered: 'メール未登録',
    emailNotification: 'メール通知',
    provider: 'OAuth提供者',
    createdAt: '登録日',
    lastLoginAt: '最終ログイン',
    profileImage: 'プロフィール画像',
    updateProfile: 'プロフィール更新',
    updateSuccess: 'プロフィールが更新されました',
    updateFailed: 'プロフィールの更新に失敗しました',
    nicknameUpdateSuccess: 'ニックネームが保存されました',
    nicknameUpdateFailed: 'ニックネームの保存に失敗しました',
    imageUpdateSuccess: 'プロフィール画像が変更されました',
    imageUpdateFailed: '画像のアップロードに失敗しました'
  },
  admin: {
    dashboard: 'ダッシュボード',
    stats: 'サービス統計',
    users: 'ユーザー管理',
    playlists: 'プレイリスト',
    reports: 'コメント報告',
    announcements: 'お知らせ',
    concerts: '公演情報',
    settings: 'システム設定',
    backToUser: 'ユーザーページへ',
    searchStats: '検索統計',
    apiUsage: 'API使用量',
    userActivity: 'ユーザーアクティビティ',
    contentStats: 'コンテンツ統計',
    popularQueries: '人気検索ワード',
    cacheHitRate: 'キャッシュヒット率',
    dailySearches: '日別検索数',
    totalApiCalls: '総API呼び出し',
    avgDailyUsage: '1日平均使用量',
    quotaUsageRate: '割当量使用率',
    dau: 'DAU',
    wau: 'WAU',
    mau: 'MAU',
    newUsers: '新規登録者',
    activeUsers: 'アクティブユーザー',
    totalPlaylists: '総プレイリスト',
    totalSongs: '総曲数',
    publicRate: '公開率',
    period: '期間',
    days7: '7日間',
    days14: '14日間',
    days30: '30日間',
    days90: '90日間'
  },
  concerts: {
    title: '公演情報',
    upcoming: '予定公演',
    past: '過去の公演',
    date: '日付',
    venue: '会場',
    artist: 'アーティスト',
    tickets: 'チケット予約',
    noUpcoming: '予定されている公演はありません',
    guide: 'ガイド',
    guideTitle: '使い方ガイド',
    domestic: '国内公演',
    global: '海外公演',
    dateSelect: '日付選択:',
    today: '今日',
    concertsCount: '公演',
    page: 'ページ',
    total: '合計',
    items: '件',
    gridView: 'グリッド',
    listView: 'リスト',
    loading: '公演情報を読み込み中...',
    venueUndecided: '会場未定',
    createPlaylist: 'プレイリスト作成',
    bookTickets: 'チケット予約',
    noConcerts: '選択した日付に公演はありません',
    tryOtherDate: '別の日付を選択してください',
    prev: '前へ',
    next: '次へ',
    playlistModal: 'プレイリスト作成',
    playlistName: 'プレイリスト名',
    playlistNamePlaceholder: 'プレイリスト',
    searchKeyword: '検索キーワード',
    searchKeywordPlaceholder: '検索キーワードを入力',
    searching: '検索中...',
    search: '検索',
    quotaExceededTitle: 'YouTube API割当量を超過しました',
    quotaExceededDesc: '次の検索ワードをクリックするとキャッシュされた結果を確認できます:',
    quotaExceededNoCache: '現在、関連するキャッシュデータがありません。別の検索ワードをお試しください。',
    recommendedQueries: 'おすすめ検索ワード',
    searchResults: '検索結果',
    songs: '曲',
    add: '追加',
    remove: '削除',
    loadingMore: '読み込み中...',
    loadMore: 'もっと見る',
    currentPlaylist: 'プレイリスト',
    cancel: 'キャンセル',
    saving: '保存中...',
    savePlaylist: 'プレイリストを保存',
    playlistModalTitle: '{title}プレイリスト作成',
    alertEnterKeyword: '検索キーワードを入力してください。',
    alertSearchError: '検索中にエラーが発生しました。',
    alertRecommendedError: 'おすすめ検索ワードの読み込み中にエラーが発生しました。',
    alertAddSongs: 'プレイリストに曲を追加してください。',
    alertEnterName: 'プレイリスト名を入力してください。',
    alertPlaylistSaved: 'プレイリスト「{name}」が正常に作成されました！（{count}曲）',
    alertPlaylistError: 'プレイリストの保存中にエラーが発生しました。',
    statusOnSale: '予約受付中',
    statusSoldOut: '完売',
    statusUpcoming: '予約予定',
    statusEnded: '終了'
  },
  practice: {
    title: '練習モード',
    selectSong: '曲を選択',
    selectSection: '練習する区間を選択',
    startPractice: '練習開始',
    repeat: 'リピート回数',
    speed: '再生速度',
    normal: '標準',
    slow: 'ゆっくり',
    fast: '速く'
  },
  auth: {
    loginTitle: 'ログイン',
    signupTitle: '会員登録',
    loginWithGoogle: 'Googleでログイン',
    loginWithNaver: 'Naverでログイン',
    loginWithKakao: 'Kakaoでログイン',
    loginRequired: 'ログインが必要です',
    loginSuccess: 'ログインしました',
    logoutSuccess: 'ログアウトしました',
    // ログインモーダル
    welcomeTitle: 'テチャンへようこそ！',
    welcomeSubtitle: '簡単にログインして自分だけのプレイリストを作りましょう',
    simpleLogin: '簡単ログイン',
    startWithGoogle: 'Googleで始める',
    startWithNaver: 'Naverで始める',
    guestMode: 'ゲストモードで体験',
    guestNotice: '※ YouTube APIレビューおよびデモ目的で提供される一時的な機能です',
    loginAgreement: 'ログインすると',
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    agreementSuffix: 'に同意したものとみなされます。',
    // 多重ログイン確認
    multiLoginTitle: 'すでにログイン中のアカウントがあります',
    multiLoginMessage1: '現在、他のデバイスでログインしています。',
    multiLoginMessage2: '続行すると、既存のログインが自動的にログアウトされます。',
    existingSessions: '既存のログインセッション:',
    deviceWeb: 'Webブラウザ',
    deviceMobile: 'モバイルアプリ',
    minutesAgo: '{minutes}分前',
    hoursAgo: '{hours}時間前',
    daysAgo: '{days}日前',
    cancelBtn: 'キャンセル',
    forceLoginBtn: '既存のログインをログアウトして続行'
  },
  footer: {
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    youtubeTerms: 'YouTube利用規約',
    googlePrivacy: 'Googleプライバシーポリシー',
    copyright: '© 2025 テチャン(Ttaechang). All rights reserved.',
    youtubeApiNotice: '本サービスはYouTube API Servicesを使用しています。',
    madeBy: '制作:',
    contact: 'お問い合わせ:'
  },
  playlistList: {
    title: 'マイプレイリスト',
    subtitle: '自分だけのファンチャントプレイリストを作成・管理',
    createBtn: '新規プレイリスト作成',
    statTotal: '総プレイリスト',
    statSongs: '総曲数',
    statPublic: '公開プレイリスト',
    statCopies: '総コピー数',
    viewGrid: 'グリッド',
    viewList: 'リスト',
    sortRecent: '最近更新順',
    sortName: '名前順',
    sortSongs: '曲数順',
    sortCreated: '作成日順',
    filterAll: 'すべて',
    filterPublic: '公開',
    filterPrivate: '非公開',
    searchPlaceholder: 'プレイリストを検索...',
    loading: 'プレイリストを読み込み中...',
    retryBtn: '再試行',
    songs: '曲',
    public: '公開',
    private: '非公開',
    tooltipEdit: '編集',
    tooltipShare: '共有',
    tooltipDelete: '削除',
    tablePlaylist: 'プレイリスト',
    tableSongCount: '曲数',
    tablePublicSetting: '公開設定',
    tableUpdatedDate: '更新日',
    tableActions: '操作',
    noPlaylists: 'プレイリストがありません',
    noPlaylistsSub: '最初のプレイリストを作成しましょう',
    createPlaylistBtn: 'プレイリスト作成',
    modalCreate: '新規プレイリスト作成',
    modalName: 'プレイリスト名',
    modalNamePlaceholder: '例: BTSファンチャントコレクション',
    modalDescription: '説明',
    modalDescriptionPlaceholder: 'このプレイリストの説明を入力',
    modalPublicCheckbox: '公開プレイリストにする',
    modalTags: 'タグ（カンマ区切り）',
    modalTagsPlaceholder: '例: ファンチャント, BTS, 初心者向け',
    modalTagsHint: '複数のタグをカンマ（,）で区切って入力',
    modalCancel: 'キャンセル',
    modalCreate: '作成',
    // formatDate
    today: '今日',
    yesterday: '昨日',
    daysAgo: '{days}日前',
    weeksAgo: '{weeks}週間前',
    unknown: '不明',
    // Activities
    activityCreated: '「{name}」プレイリスト作成',
    activityEdited: '「{name}」プレイリスト編集',
    activityShared: '「{name}」プレイリスト共有',
    activityNone: 'まだアクティビティがありません',
    activityNoneSub: 'プレイリストを作成しましょう！',
    // Alerts
    alertDeleteConfirm: '「{name}」プレイリストを削除しますか？',
    alertDeleteFailed: 'プレイリストの削除に失敗しました。',
    alertLoadFailed: 'プレイリストを読み込めません: {message}',
    alertCreateFailed: 'プレイリストの作成に失敗しました',
    alertNoDescription: '新しいプレイリスト',
    alertJustNow: 'たった今',
    // Others
    noUserId: 'ユーザーIDがありません',
    loadingSongs: '曲を読み込み中...',
    noSongInfo: '曲情報なし',
    unknownArtist: '不明',
    noTitle: 'タイトルなし'
  },

  // PlaylistFeed (コミュニティプレイリストフィード)
  playlistFeed: {
    title: '🎵 プレイリストコミュニティ掲示板',
    description: '他のユーザーが共有したプレイリストを探してお気に入りをブックマーク',
    searchPlaceholder: 'タイトル、説明、作成者、タグで検索...',
    searchBtn: '🔍 検索',
    sortRecent: '最新順',
    sortPopular: '人気順',
    sortMostLiked: 'いいね順',
    sortMostViewed: '閲覧数順',
    sortMostCopied: 'コピー順',
    sortMostBookmarked: 'ブックマーク順',
    filterAllSongs: 'すべての曲数',
    filter5Plus: '5曲以上',
    filter10Plus: '10曲以上',
    filter20Plus: '20曲以上',
    popularTagsTitle: '🏷️ 人気タグ',
    selectedTagsLabel: '選択されたタグ:',
    clearAllTags: 'すべてクリア',
    loading: 'プレイリストを読み込み中...',
    retryBtn: '再試行',
    songs: '曲',
    noDescription: '説明なし',
    authorLabel: '作成者:',
    emptyState: '公開されているプレイリストがありません',
    prevPage: '◀ 前へ',
    nextPage: '次へ ▶',
    loadError: 'プレイリストの読み込みに失敗しました。',
    bookmarkError: 'ブックマーク処理に失敗しました。',
    thumbnailAlt: '曲{index}のサムネイル'
  },

  // FanchantArchive (ファンチャント動画アーカイブ)
  fanchantArchive: {
    title: '🎬 ファンチャント動画アーカイブ',
    description: 'K-popコンサートの感動的なファンチャントの瞬間を集めました',
    guideBtn: 'ガイド',
    guideBtnTooltip: '使い方ガイド',
    searchPlaceholder: 'アーティストや曲名でファンチャント動画を検索...',
    searchBtn: '🔍 検索',
    tabTrendingShorts: '急上昇ショート',
    tabTrendingRegular: '急上昇通常',
    tabPopularShorts: '累積人気ショート',
    tabPopularRegular: '累積人気通常',
    tabSearch: '検索',
    loading: 'ファンチャント動画を読み込み中...',
    retryBtn: '再試行',
    totalVideos: '合計{count}本の動画',
    displayedVideos: '（{displayed}本表示）',
    lastUpdate: '最終更新: {date}',
    searchResultTitle: '🔍 「{query}」の検索結果',
    emptySearch: '検索結果がありません',
    emptySearchSub: '別の検索ワードをお試しください',
    emptyDefault: 'ファンチャント動画を検索しましょう！',
    emptyDefaultSub: 'アーティスト名や曲名を入力して感動的なファンチャントの瞬間を見つけましょう',
    videoSuffix: 'ファンチャント動画',
    loadTrendingShortsError: '急上昇ショートのファンチャント動画の読み込みに失敗しました。',
    loadTrendingRegularError: '急上昇通常のファンチャント動画の読み込みに失敗しました。',
    loadPopularShortsError: '累積人気ショートのファンチャント動画の読み込みに失敗しました。',
    loadPopularRegularError: '累積人気通常のファンチャント動画の読み込みに失敗しました。',
    searchError: '検索に失敗しました。',
    searchNotFound: '「{query}」のファンチャント動画が見つかりません。別の検索ワードをお試しください。'
  },

  // Pagination (ページング)
  pagination: {
    previous: '前へ',
    next: '次へ',
    previousPage: '前のページ',
    nextPage: '次のページ',
    itemsCount: '{start}-{end} / {total}件'
  },

  // Comments (コメント)
  comments: {
    title: '💬 コメント',
    count: '{count}件',
    sortLatest: '新しい順',
    sortPopular: '人気順',
    writePlaceholder: 'コメントを書く...',
    cancel: 'キャンセル',
    submitting: '投稿中...',
    submit: 'コメント投稿',
    loginRequired: 'コメントを書くには',
    loginLink: 'ログイン',
    loginRequiredSuffix: 'が必要です。',
    loading: 'コメントを読み込み中...',
    noComments: 'まだコメントがありません。',
    firstComment: '最初のコメントを書いてみましょう！',
    loadMore: 'さらにコメントを読み込む',
    replyTitle: '返信を書く',
    replyTo: '{name}さんへの返信',
    replyPlaceholder: '返信を書く...',
    replySubmitting: '投稿中...',
    replySubmit: '返信投稿',
    reportTitle: 'コメントを報告',
    reportReason: '報告理由',
    reportReasonPlaceholder: '理由を選択してください',
    reportReasonSpam: 'スパム',
    reportReasonAbuse: '中傷的な表現',
    reportReasonInappropriate: '不適切な内容',
    reportReasonHate: 'ヘイトスピーチ',
    reportReasonOther: 'その他',
    reportDescription: '詳細説明（任意）',
    reportDescriptionPlaceholder: '報告理由の詳細を入力してください...',
    reportSubmitting: '報告中...',
    reportSubmit: '報告する',
    alertLoginRequired: 'ログインが必要です。',
    alertCommentFailed: 'コメントの投稿に失敗しました。',
    alertReplyFailed: '返信の投稿に失敗しました。',
    alertEditFailed: 'コメントの編集に失敗しました。',
    alertDeleteConfirm: '本当にこのコメントを削除しますか？',
    alertDeleteFailed: 'コメントの削除に失敗しました。',
    alertReportSuccess: '報告が送信されました。',
    alertReportFailed: '報告の送信に失敗しました。'
  },

  // Announcements (お知らせ)
  announcements: {
    title: 'お知らせ',
    loading: 'お知らせを読み込み中...',
    noAnnouncements: 'お知らせはありません。',
    readMore: '詳細を見る',
    back: '戻る',
    backToList: 'リストに戻る',
    notFound: 'お知らせが見つかりません。',
    loadError: 'お知らせの読み込みに失敗しました。'
  }
}
